
@switch (type) {
  @case ('confirmed') {
    @if (history?.confirmed) {
      <div class="order-modal-box-history">
        @for (confirmed of (history['confirmed']); track confirmed) {
          <div class="order-modal-box-history-item">
            <div class="order-modal-box-history-item-head">
              {{ confirmed.date_created|date: "dd.MM.yyyy HH:mm"}} - {{ confirmed.username}}
            </div>
            <div class="order-modal-box-history-item-content">
              <order-box-history-confirmed type="confirmed" [history]="confirmed.data"></order-box-history-confirmed>
            </div>
          </div>
        }
      </div>
    }
  }
  @case ('conveyed') {
    @if (history?.conveyed) {
      <div class="order-modal-box-history">
        @for (conveyed of history['conveyed']; track conveyed) {
          <div class="order-modal-box-history-item">
            <div class="order-modal-box-history-item-head">
              {{ conveyed.date_created|date: "dd.MM.yyyy HH:mm" }} - {{ conveyed.username}}
            </div>
            <div class="order-modal-box-history-item-content">
              <div class="order-modal-box-history-item-content">
                <order-box-history-conveyed type="conveyed" [history]="conveyed.data"></order-box-history-conveyed>
              </div>
            </div>
          </div>
        }
      </div>
    }
  }
  @case ('received') {
    @if (history?.received) {
      <div class="order-modal-box-history">
        @for (received of history['received']; track received) {
          <div class="order-modal-box-history-item">
            <div class="order-modal-box-history-item-head">
              {{ received.date_created|date: "dd.MM.yyyy HH:mm" }} - {{ received.username}}
            </div>
            <div class="order-modal-box-history-item-content">
              <order-box-history-received type="received" [history]="received.data"></order-box-history-received>
            </div>
          </div>
        }
      </div>
    }
  }
  @case ('reviewed') {
    @if (history?.reviewed) {
      <div class="order-modal-box-history">
        @for (reviewed of history['reviewed']; track reviewed) {
          <div class="order-modal-box-history-item">
            <div class="order-modal-box-history-item-head">
              {{ reviewed.date_created|date: "dd.MM.yyyy HH:mm"}} - {{ reviewed.username}}
            </div>
            <div class="order-modal-box-history-item-content">
              <order-box-history-reviewed type="reviewed" [history]="reviewed.data"></order-box-history-reviewed>
            </div>
          </div>
        }
      </div>
    }
  }
  @case ('expensed') {
    @if (history?.expensed) {
      <div class="order-modal-box-history">
        @for (expensed of history['expensed']; track expensed) {
          <div class="order-modal-box-history-item">
            <div class="order-modal-box-history-item-head">
              {{ expensed.date_created|date: "dd.MM.yyyy HH:mm"}} - {{ expensed.username}}
            </div>
            <div class="order-modal-box-history-item-content">
              <order-box-history-expensed type="expensed" [history]="expensed.data"></order-box-history-expensed>
            </div>
          </div>
        }
      </div>
    }
  }
}
